export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-06-13 at 22.28.59 (2).1b7d320a.jpeg";